<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Sauvegarde de colis</h2>
                <form @submit.prevent="createSavePoint">
                    <fieldset class="uk-fieldset">
                        <div class="uk-margin">
                            <label for="">Lieu de livraison</label>
                            <input class="uk-input" type="numeric" v-model="savepoint.dest_address" placeholder="Lieu de livraison" required> 
                        </div>
                        <div class="uk-margin">
                            <label for="">Nature du colis</label>
                            <input class="uk-input" type="text" v-model="savepoint.nature" placeholder="Nature du colis" required>
                        </div>
                        <div class="uk-margin">
                            <label for="">Nom du client</label>
                            <input class="uk-input" type="text" v-model="savepoint.client_name" placeholder="Nom du client" required>
                        </div>
                        <div class="uk-margin">
                            <label for="">Contact du client</label>
                            <input class="uk-input" type="text" v-model="savepoint.dest_contact" placeholder="Numéro de destination" required>
                        </div>
                        <div class="uk-margin">
                            <label for="">Montant du colis</label>
                            <input class="uk-input" type="numeric" v-model="savepoint.valeur" placeholder="Montant du colis" required> 
                        </div>
                        <div class="uk-margin">
                            <select class="uk-select" placeholder="Livré ou Retour">
                                <option :value="'livré'" >Livré</option>
                                <option :value="'retour'" >Retour</option>
                            </select>
                        </div>

                    </fieldset>
                    <div class="d-flex justify-content-center">
                        <button class="btn btn-round my-3 border-0 px-5" style="background-color:#FFAB0E; color:#fff;  font-size:1em !important; " >Sauvegarder</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { dbstore, auth } from '../../main';
import Swal from "sweetalert2";
import uid from "short-unique-id";

export default {
    data(){
        return{
            savepoint: {
                client_name: "",
                created_at:"",
                dest_address:"",
                dest_contact:"",
                valeur: "",
                nature:"",
                status:"",
            },
        }
        
    },
    methods: {
        createSavePoint(event){
            const uuid = new uid({ length: 5 })
            const myuid = 'BT-' + uuid().toUpperCase()
            const current = new Date();
            const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
            const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
            const dateTime = date +' '+ time;
            const created_at = dateTime;
            const svpt = this.savepoint;
            const savept = dbstore
            // dbstore.collection('test').doc('test1').collection('savepoints').add({
            //     client_name: svpt.client_name,
            //     // key: doc.id,
            //     created_at:created_at,
            //     dest_address:svpt.dest_address,
            //     dest_contact:svpt.dest_contact,
            //     valeur:svpt.valeur,
            //     nature:svpt.nature,
            //     status:svpt.status,
            //     uuid:myuid,
            // })
            const museums = dbstore.collection('test');
                museums.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        const getID = doc.id;
                        console.log(getID, ' => ', doc.data());
                    });
                });
            dbstore.collection('test').doc(getID).collection('savepoints').add({
                client_name: svpt.client_name,
                created_at:created_at,
                dest_address:svpt.dest_address,
                dest_contact:svpt.dest_contact,
                valeur:svpt.valeur,
                nature:svpt.nature,
                status:svpt.status,
                uuid:myuid,
            })
            this.$router.push({ path: "/admin/livraison/savepoint" });
            event.target.reset();
            event.preventDefault();
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Crée avec succès",
                showConfirmButton: true,
                timer: 4000,
                allowOutsideClick: false,
            });
        }
    },
}
</script>